<template>
  <iColumn>
    <iText>You're updating your account settings for inspiration.co.</iText>
    <iText>Any changes made on this page will apply directly to your inspiration.co account.</iText>

    <!-- Static mock of @/components/UserAccountManagement. The real
         surface is store-bound (email/password/avatar mutations) and
         renders in FanWeb; the editor canvas only previews its look,
         seeded from the mixin's example entity. -->
    <iColumn>
      <iRow>
        <iLabel>Avatar</iLabel>
      </iRow>
      <iRow vertical-align="middle">
        <iImageContainer
          :src="avatarUrl"
          alt="avatar"
          shape="circle"
          :width="75"
          :height="75"
          :crop-if-needed="true"
        />
        <iButton>Change Picture</iButton>
      </iRow>

      <iRow width="hug">
        <iTextEditInput
          :model-value="entity.email"
          label="Email"
          :min-width="400"
        />
      </iRow>
      <iRow width="hug">
        <iTextEditInput
          model-value="*************"
          label="Password"
          :min-width="400"
          editable-on-click
        />
      </iRow>
      <iRow width="hug">
        <iTextEditInput
          :model-value="entity.firstName"
          label="First Name"
          :min-width="400"
        />
      </iRow>
      <iRow width="hug">
        <iTextEditInput
          :model-value="entity.lastName"
          label="Last Name"
          :min-width="400"
        />
      </iRow>
      <iRow width="hug">
        <iRadioBar
          model-value="unset"
          :options="themeModeOptions"
          label="Theme Mode"
        />
      </iRow>
    </iColumn>
  </iColumn>
</template>

<script>
// Editor-directory copy of FanWeb's UserAccount element. Kept
// self-contained inside the editor boundary: example data comes from
// the UserSettingsPageElementMixin entity, so no FanWeb stores or the
// real UserAccountManagement surface leak in.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";
import { DEFAULT_USER_AVATAR } from "%/dynamic-component-editor/constants/user-constants";

export default {
  name: "UserAccount",
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Inspiration Account Management",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  computed: {
    avatarUrl() {
      return this.entity.avatarUrl || DEFAULT_USER_AVATAR;
    },
    themeModeOptions() {
      return [
        { value: "light-mode", label: "Light Mode", tooltip: "" },
        { value: "dark-mode", label: "Dark Mode", tooltip: "" },
        { value: "unset", label: "System Default", tooltip: "" },
      ];
    },
  },
};
</script>
